import { inject } from '@angular/core';
import type { ApolloLink, DefaultContext, TypedDocumentNode } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import type { Observable } from 'rxjs';

/**
 * static-graphql-documents (D3): typed from the passed `TypedDocumentNode` —
 * see `mutate-create.ts` for the generic-defaults rationale. `keys` IS the
 * whole variables object (no wrapper key), matching the where-based
 * composite-key delete mutation shape.
 */
export function mutateDeleteByKeys<
  TData extends object = Record<string, unknown>,
  TVariables extends Record<string, unknown> = Record<string, unknown>,
>(
  mutation: TypedDocumentNode<TData, TVariables>,
  keys: TVariables,
  headers?: Record<string, string>,
): Observable<ApolloLink.Result<TData>> {
  const apollo = inject(Apollo);
  return apollo.mutate<TData, TVariables>({
    mutation,
    variables: keys,
    context: { headers } as DefaultContext,
  });
}
